import { render } from "./Subscribes.vue?vue&type=template&id=454aee56"
import script from "./Subscribes.vue?vue&type=script&lang=js"
export * from "./Subscribes.vue?vue&type=script&lang=js"

import "./Subscribes.vue?vue&type=style&index=0&id=454aee56&lang=css"

import exportComponent from "/Users/animatik/Sites/Vitalhit/Pay/id/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__